
export enum ProfileTab {
    ProfileDetails = 'details',
    SavedAddresses = 'addresses',
    OrderHistory = 'orders'
}